/**
 * In-memory кэш с TTL для снижения нагрузки на API
 */

interface CacheEntry<T> {
  data: T;
  timestamp: number;
  ttl: number; // Время жизни в миллисекундах
}

class Cache {
  private store = new Map<string, CacheEntry<any>>();
  private defaultTTL = 5 * 60 * 1000; // 5 минут по умолчанию

  /**
   * Получить данные из кэша
   */
  get<T>(key: string): T | null {
    const entry = this.store.get(key);
    if (!entry) return null;

    const now = Date.now();
    if (now - entry.timestamp > entry.ttl) {
      this.store.delete(key);
      return null;
    }

    return entry.data as T;
  }

  /**
   * Сохранить данные в кэш
   */
  set<T>(key: string, data: T, ttl?: number): void {
    this.store.set(key, {
      data,
      timestamp: Date.now(),
      ttl: ttl ?? this.defaultTTL,
    });
  }

  /**
   * Очистить весь кэш (например, при принудительном обновлении)
   */
  clear(): void {
    this.store.clear();
  }

  /**
   * Удалить конкретный ключ (например, при мутации данных, если она появится)
   */
  delete(key: string): void {
    this.store.delete(key);
  }
}

export const cache = new Cache();